export function cx(...values) {
  return values.flat(Infinity).filter(Boolean).join(' ');
}

export function toDataAttrs(attrs) {
  if (!attrs) {
    return {};
  }
  const out = {};
  Object.entries(attrs).forEach(([key, value]) => {
    if (value == null || value === false) {
      return;
    }
    out[key] = value === true ? '' : String(value);
  });
  return out;
}
